import React from "react";
import EventsTimeFilter from "features/activity/components/EventsTimeFilter";
import ChartTypeDropdown from "./ChartTypeDropdown";
import TimeSeriesIntervalDropdown from "./TimeSeriesIntervalDropdown";
import FunnelTableColumnSettings from "./FunnelTableColumnSettings";

/**
 * Shared report header: date range selector + chart type dropdown.
 * Same for Insight and Funnel; chart dropdown options come from reportType.
 * @param {"insight" | "funnel"} reportType
 * @param {object} timeFilterState - { selectedPreset, onTimeFilterChange } for EventsTimeFilter
 * @param {string} chartType - current chart type id
 * @param {(id: string) => void} onChartTypeChange
 */
export default function ReportHeader({
  reportType,
  selectedPreset,
  onTimeFilterChange,
  chartType,
  onChartTypeChange,
  insightSeriesInterval = "day",
  onInsightSeriesIntervalChange,
  showInsightSeriesInterval = false,
  funnelMeasuring,
  funnelTableColumns,
  onFunnelTableColumnsChange,
  showFunnelTableSettings,
}) {
  return (
    <div
      className="flex items-center gap-2 flex-1 flex-wrap"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <EventsTimeFilter selectedPreset={selectedPreset} onTimeFilterChange={onTimeFilterChange} />
      <ChartTypeDropdown
        reportType={reportType}
        chartType={chartType}
        onChartTypeChange={onChartTypeChange}
        funnelMeasuring={funnelMeasuring}
      />
      {showFunnelTableSettings &&
        typeof onFunnelTableColumnsChange === "function" &&
        funnelTableColumns && (
          <FunnelTableColumnSettings
            columns={funnelTableColumns}
            onColumnsChange={onFunnelTableColumnsChange}
          />
        )}
      {showInsightSeriesInterval && typeof onInsightSeriesIntervalChange === "function" && (
        <TimeSeriesIntervalDropdown
          value={insightSeriesInterval}
          onChange={onInsightSeriesIntervalChange}
        />
      )}
    </div>
  );
}
